import { lazy } from 'react';

export const ADDRESS_ROUTE = [
    {
        path: '/address',
        exact: true,
        component: lazy(() => import('@/page/address/pages/AddressHome/index')),
    },
    {
        // 目前线上暂无AddressAdd页面
        path: '/address/add',
        component: lazy(() => import('@/page/address/pages/AddressAddV2/index')),
    },
    {
        path: '/address-half/add',
        component: lazy(() => import('@/page/address/pages/AddressAddV2/index')),
    },
    {
        path: '/address/addV2',
        component: lazy(() => import('@/page/address/pages/AddressAddV2/index')),
    },
    {
        path: '/address/pcd-select',
        component: lazy(() => import('@/page/address/pages/AddressPcdSelect/index')),
    },
    {
        path: '/address/street',
        component: lazy(() => import('@/page/address/pages/AddressStreet/index')),
    },
];
